var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { apiGetListRfpNegotiate, apiUpdateProfessionalRfpMessage, } from '@/actions/ProfessionalRfpNegotiateActionsTs';
import { apiCreateProfessionalRfpMessageLog } from '@/actions/ProfessionalRfpNegotiateActionsTs/create';
import { messageFieldName } from '@/components/modules/Chat/ChatForm/ChatForm';
import { ProfessionalRfpNegotiateView } from '@/components/pages/rfp/professional/ProfessionalRfpNegotiateView/ProfessionalRfpNegotiateView';
import Layout from '@/container/Layout';
import { notify } from '@/helpers/action';
import { isAdmin } from '@/helpers/auth';
import { wrapDispatch } from '@/utils/actions/dispatch';
import { RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC, RFP_NEGOTIATE_MESSAGE_STATUSES, } from '@/utils/constants/rfp/rfpNegotiate/rfpNegotiateMessage/status';
/**
 * コンサルタント：案件条件相談ページを表示するためのコンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalNegotiatePage = (props) => {
    const { negotiate, profile, rfp } = props;
    /** ログインユーザーの情報 */
    const user = useMemo(() => ({
        clientId: '',
        firstName: profile.information.firstName,
        imageSrc: profile.information.file,
        isShowDetailPage: false,
        lastName: profile.information.lastName,
        professionalId: `${profile.id}`,
        professionalType: profile.information.type,
    }), [profile]);
    const { id } = rfp;
    const dispatch = useDispatch();
    /** メッセージ更新 */
    const onClickSubmit = useCallback((args, form) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        // データ更新
        yield wrapDispatch(dispatch, apiUpdateProfessionalRfpMessage({ json: args, path: { id } }, {}));
        // トースト表示
        const notifyMessage = (_a = RFP_NEGOTIATE_MESSAGE_STATUSES.find((v) => v.value === args.status)) === null || _a === void 0 ? void 0 : _a.message;
        if (notifyMessage) {
            notify(`${notifyMessage}しました`);
        }
        form.batch(() => {
            // メッセージが公開されていた場合はフォームの値を空にする
            if (args.status === RFP_NEGOTIATE_MESSAGE_STATUS_PUBLIC.value) {
                form.change(messageFieldName, '');
            }
            form.resetFieldState(messageFieldName);
        });
        // データ引き直し
        yield wrapDispatch(dispatch, apiGetListRfpNegotiate({ path: { id } }, {}));
    }), [dispatch, id]);
    /** 最終メッセージが表示されたタイミングで既読ログ更新 */
    const displayLastMessage = useCallback((messageId) => {
        // 既読更新
        dispatch(apiCreateProfessionalRfpMessageLog({
            path: {
                id,
                rfpNegotiateMessageId: messageId,
            },
        }, {}));
    }, [id, dispatch]);
    return (_jsx(Layout, Object.assign({ mainClassName: 'l-main rfp_common_container' }, { children: _jsx(ProfessionalRfpNegotiateView, { displayLastMessage: displayLastMessage, isAdminUser: isAdmin(profile), negotiate: negotiate, onClickSubmit: onClickSubmit, professionalId: profile.id, rfp: rfp, user: user }) })));
};
